import types from './userTypes'

const initialState = {
  userAdded: null,
  userLogged: null,
  error: null,
  rememberMe: false
}

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case types.ADD_USER:
      return {
        ...state,
        userAdded: null,
        error: null
      }
    case types.ADD_USER_SUCCESS:
      return {
        ...state,
        userAdded: payload
      }
    case types.ADD_USER_FAILURE:
      return {
        ...state,
        userAdded: payload.data,
        error: payload.message
      }
    case types.SET_REMEMBER_ME:
      return {
        ...state,
        rememberMe: !state.rememberMe
      }
    default:
      return state
  }
}
